import { UtilityService } from './../../shared/services/utility.service';
import { Api } from './../../shared/constants/api';
import { DataService } from './../../shared/services/data.service';
import { NGXLogger } from 'ngx-logger';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-forget-password',
    templateUrl: './forget-password.component.html',
    styleUrls: ['./forget-password.component.less'],
    standalone: false
})
export class ForgetPasswordComponent implements OnInit {

  forgetPassword:FormGroup;
  constructor(private router:Router,private logger: NGXLogger,private formBuilder:FormBuilder,private service: DataService,private utilityService: UtilityService) { }
  ngOnInit(): void {
    localStorage.clear();
    this.initializeForm();
    this.logger.info('forgotPassword form data in init method : ',this.forgetPassword.value);
  }
  /**
   * this method will initialize form
   */
  private initializeForm()  {
    this.forgetPassword = this.formBuilder.group({
      mail: [null, [Validators.required, Validators.email]]
    });
    this.logger.info('forgotPassword form data in initializeForm method : ',this.forgetPassword.value);
  }

  /**
   * this method will submit the form
   * after submit trigger an email for reset password url
   */
  public onSubmit() {
    this.logger.info('forget- password submit button works data is : ', this.forgetPassword.value);
    this.logger.info('forget- password url  : ', Api.FORGET_PASSWORD);
    this.logger.info('forget- password data  : ', this.forgetPassword.value);
    if(!this.forgetPassword.invalid){
      this.service.post(Api.FORGET_PASSWORD,this.forgetPassword.value).subscribe(res => {
        if (res) {
          this.logger.info('forget password response', res);
          this.utilityService.notifier(res.response,'success');
        }
      });
    }
  }
  /**
   * this method will cancle the form
   */
  public onCancel(){
    this.logger.info('forget- password cancle button works');
    this.router.navigate(['/login'])
  }

  /**
   * onResend
   */
  public onResend() {
    this.logger.info('forget- password resend button works');
  }

}
